import BaseComponent from "../../redare/components/BaseComponent";
import {message, Modal} from "antd";
import React from "react";
import UserPresenter from "../../.gen/presenter/UserPresenter";
import UserFormContent from "./UserFormContent";

export default class UserForm extends BaseComponent {

    static defaultProps = {
        parentComponent: undefined
    }

    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false,
            showLoading: false,
            userId: undefined
        }
        this.userPrestnter = new UserPresenter(this);
    }

    componentDidMount() {

    }

    _show({userId, title}) {
        this.setState({modalVisible: true, userId, title})
    }

    _hide() {
        this.setState({modalVisible: false, showLoading: false})
    }

    _onGetUserSuccess(result) {
        this.setState({info: result.data})
    }

    _onAddEditMemberSave() {
        //编辑、添加用户保存
        let {userId} = this.state;
        this.formContent.form.validateFields().then(values => {
            this.setState({showLoading: true});
            let loginUser = window._workbench._user;
            values.platform = loginUser.platform;
            if (userId) {
                values.where = {userId: userId};
                this.userPrestnter.modifyUser(
                    values,
                    {},
                    (result) => {
                        this.toastSuccess("编辑成功");
                        this.props.parentComponent._reloadUserMember();
                        this._hide()
                    },
                    () => {
                        this.setState({showLoading: false})
                    }
                )
            } else {
                this.userPrestnter.addUser(
                    values,
                    {},
                    () => {
                        this.toastSuccess("添加成功");
                        this.props.parentComponent._reloadUserMember();
                        this._hide()
                    },
                    (err) => {
                        this.setState({showLoading: false});
                    }
                )
            }
        }).catch(errorInfo => {

        });
    }

    render() {
        let {modalVisible, title, showLoading, userId} = this.state;
        return (
            <Modal
                title={title}
                visible={modalVisible}
                onOk={() => this._onAddEditMemberSave()}
                onCancel={() => this._hide()}
                destroyOnClose={true}
                maskClosable={false}
                confirmLoading={showLoading}
                centered={true}
                okText={'保存'}
                cancelText={'取消'}
                width={'760px'}
            >
                <UserFormContent isEdit={userId} userId={userId} ref={(add) => {
                    this.formContent = add
                }}/>
            </Modal>
        )
    }
}
